import { Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { useState } from "react";

import { VariantAttributeModal } from "@/components/product/variant-attributes/attribute-form";
import { VariantAttributesList } from "@/components/product/variant-attributes/attribute-list";
import {
  variantAttributeKeys,
} from "@/hooks/api/variant-attributes";
import { PageLayout } from "@/layouts/page";
import { queryClient } from "@/main";
import { VariantAttribute } from "@/types/product";

export const VariantAttributesPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAttribute, setEditingAttribute] =
    useState<VariantAttribute | null>(null);

  const invalidateAttributes = () => {
    queryClient.invalidateQueries({
      queryKey: variantAttributeKeys.lists(),
    });
  };

  const handleOpenCreate = () => {
    setEditingAttribute(null);
    setIsModalOpen(true);
  };

  const handleEditAttribute = (attribute: VariantAttribute) => {
    setEditingAttribute(attribute);
    setIsModalOpen(true);
  };

  const handleOpenChange = (open: boolean) => {
    setIsModalOpen(open);
    if (!open) setEditingAttribute(null);
  };

  return (
    <PageLayout
      buttons={[
        <Button key="create" variant="primary" onPress={handleOpenCreate}>
          <Icon fontSize={18} icon="solar:add-circle-linear" />
          Create Attribute
        </Button>,
      ]}
      description="Manage variant attributes for products"
      title="Variant Attributes"
    >
      <VariantAttributesList onEditAttribute={handleEditAttribute} />

      <VariantAttributeModal
        editingAttribute={editingAttribute}
        isOpen={isModalOpen}
        onOpenChange={handleOpenChange}
        onSuccess={invalidateAttributes}
      />
    </PageLayout>
  );
};

export default VariantAttributesPage;
